import React, { useEffect } from "react";
import styled from "styled-components";
import AOS from "aos";
import "aos/dist/aos.css";  // Import AOS styles

function Hero({ title, description, videosrc }) {
  useEffect(() => {
    AOS.init({
      duration: 1200,  // Global duration of animations
    });
  }, []);

  return (
    <HeroContainer>
      <video src={videosrc} autoPlay muted loop />
      <Content>
        <h1 className='shine' data-aos="fade-up">{title}</h1>

        <p data-aos="fade-up">{description}</p>
      </Content>
      <Overlay />
    </HeroContainer>
  );
}

const HeroContainer = styled.div`
  width: 100vw;
  height: 70vh; 
  position: relative;
  overflow: hidden;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(
    to top, 
   rgb(8,9,10) 0%, 
    rgba(0, 0, 0, 0.7) 50%, 
    rgba(0, 0, 0, 0) 100%
  );
  z-index: 1;
`;

const Content = styled.div`
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  z-index: 2;
  padding: 0 20px;
  width: 95%; 
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column; 

  @media only screen and (max-width: 768px) {
    width: 95%; /* 95% width on mobile */
  top: 50%;

  }

  h1 {
    font-size: 32px;
    font-family: "Cambay", sans-serif;
    font-weight: 600;
    text-transform: uppercase;

    @media only screen and (max-width: 1200px) {
      font-size: 32px;
    }

    @media only screen and (max-width: 768px) {
      font-size: 24px;
    }
  }

  p {
  width: 67%;
  text-align: center;
    font-size: 16px;
    line-height: 1.5;
    
    @media only screen and (max-width: 1200px) {
      font-size: 16px;
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
    }
  }
`;

export default Hero;
